import { domain } from 'modules/data';
import { signUpOauthProviderStorageKey } from 'shared/constants';

export const getSignupType = () => {
    const ignUpOauthProvider = localStorage.getItem(signUpOauthProviderStorageKey);

    switch (ignUpOauthProvider) {
        case domain.OAuthProvider.Xero:
            return 'xero sso';

        case domain.OAuthProvider.QBooks:
            return 'qbooks sso';

        case domain.OAuthProvider.Google:
            return 'google sso';

        case domain.OAuthProvider.Microsoft:
            return 'microsoft sso';

        default:
            return 'email';
    }
};
